<!--
 * @Author: xiaodong
 * @LastEditors: gxd
 * @Date: 2020-09-17 16:45:23
 * @LastEditTime: 2020-11-09 19:20:55
 * @Description: File description
-->
<template>
  <div class="exchange-success-popup">
    <!-- 地址确认弹框 -->
    <van-popup v-model="show" class="x-van-popup">
      <div class="exchange-success-popup-close" @click="closePopup()"></div>
      <div class="exchange-success-popup-container">
        <div class="exchange-success-popup-img">
          <img src="../assets/images/v4.0/success-check.png" alt="成功">
        </div>
        <div class="exchange-success-popup-title">兑换{{selectedGift.prize_name}}成功</div>
        <div class="exchange-success-popup-tips">5-10个工作日内发货，请您耐心等待</div>
      </div>
      <div class="exchange-success-popup-footer">
        <div class="popup-close" @click="closePopup()">
          好的
        </div>
        <div class="exchange-success-popup-express">小贴士：请在APP【我的--查快递】查看物流详情</div>
      </div>
    </van-popup>
  </div>
</template>
<script>

import { mapState } from 'vuex'

export default {
  name: 'exchangeSuccess',
  computed: mapState(['selectedGift']),
  data () {
    return {
      show: false
    }
  },
  props: {
    isShow: {
      typy: Boolean,
      default: false
    }
  },
  watch: {
    isShow (val) {
      this.show = val
    },
    show (val) {
      console.log('show----', val)
      if (!val) {
        this.$emit('closePopup')
      }
    }
  },
  methods: {
    // 关闭弹框
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>
<style lang="less" scoped>

.exchange-success-popup {
  width: 100%;
  height: 100%;

  .x-van-popup {
    width: 80%;
    border-radius: 5px;
  }

  .exchange-success-popup-close {
    position: absolute;
    top: 10px;
    right: 8px;
    width: 20px;
    height: 20px;
    background: url('../assets/images/v4.0/close-gray.png') no-repeat;
    background-size: 100%;
  }

  .exchange-success-popup-container {
    .exchange-success-popup-img {
      height: 34px;
      margin-top: 27px;

      img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }

    .exchange-success-popup-title {
      margin-top: 12px;
      font-size: 16px;
      color: #333;
    }

    .exchange-success-popup-tips {
      margin-top: 21px;
      font-size: 12px;
      color: #666;
    }
  }

  .exchange-success-popup-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 22px;
    margin-bottom: 26px;

    .popup-close {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 231px;
      height: 36px;
      font-weight: 500;
      text-align: center;
      color: #fff;
      background-image: linear-gradient(#e02727, #ff4330);
      border: 1px solid transparent;
      border-radius: 18px;
    }

    .exchange-success-popup-express {
      width: 100%;
      padding: 0 20px;
      margin-top: 10px;
      font-size: 10px;
      font-weight: 400;
      color: #e02727;
    }
  }
}
</style>
